export default __webpack_public_path__ + "static/media/no-data.ac931dde.svg";